import LegalPrivacyShell from "@/pages/LegalPrivacyShell";
import { useT } from "@/i18n/LanguageContext";

export default function Privacy() {
    const { t } = useT();
    const P = t.privacy;
    const sections = [
        { label: P.s1Label, heading: P.s1Heading, body: P.s1Body },
        { label: P.s2Label, heading: P.s2Heading, body: P.s2Body },
        { label: P.s3Label, heading: P.s3Heading, body: P.s3Body },
        { label: P.s4Label, heading: P.s4Heading, body: P.s4Body },
        { label: P.s5Label, heading: P.s5Heading, body: P.s5Body },
        { label: P.s6Label, heading: P.s6Heading, body: P.s6Body },
        { label: P.s7Label, heading: P.s7Heading, body: P.s7Body },
    ];
    return <LegalPrivacyShell titleKey={P.title} sections={sections} />;
}
